/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Mark_Rented_ConfirmInputs */

const cs_property_mark_rented_confirm = /** @type {(inputs: Property_Mark_Rented_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit jako pronajaté? Inzerát se skryje na webu a odebere ze všech zapnutých portálů.`)
};

const en_property_mark_rented_confirm = /** @type {(inputs: Property_Mark_Rented_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as rented? The listing will be hidden on the website and removed from all enabled portals.`)
};

/**
* | output |
* | --- |
* | "Mark as rented? The listing will be hidden on the website and removed from all enabled portals." |
*
* @param {Property_Mark_Rented_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_mark_rented_confirm = /** @type {((inputs?: Property_Mark_Rented_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Mark_Rented_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_mark_rented_confirm(inputs)
	return cs_property_mark_rented_confirm(inputs)
});